import { Box, Grid, Typography } from "@material-ui/core";
import FilmTagForm from "./filmTagForm";

export default function FilmTagEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
            Film &gt; Edit Film Tag
        </Typography>
      </Box>
      <Grid container xs={6}>
        <FilmTagForm
          description="Edit Tag"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
